export const ROLES = {
  SUPERADMIN: 0,
  ADMIN:      1,
  USER:       2,
  AGENT:      3,
};

export const ROLE_LABELS = {
  0: 'Superadmin',
  1: 'Admin',
  2: 'User',
  3: 'Agent',
};

export const ROLE_COLORS = {
  0: { bg: '#fed7d7', color: '#c53030' },
  1: { bg: '#feebc8', color: '#c05621' },
  2: { bg: '#e9d8fd', color: '#6b46c1' },
  3: { bg: '#c6f6d5', color: '#276749' },
};

// Segédfüggvény: van-e admin jog? (superadmin vagy admin)
export const isAdmin = (role) => role === ROLES.SUPERADMIN || role === ROLES.ADMIN;

// Segédfüggvény: kezelhet-e case-eket? (agent, admin, superadmin)
export const isAgent = (role) =>
  role === ROLES.AGENT || role === ROLES.ADMIN || role === ROLES.SUPERADMIN;
